import { Grid, Typography } from "@mui/material";
import { getLineupScore, getLineupFpts } from "src/components/versus/utils";

export function GameScore({ lineupA, lineupB, userA, userB }) {
  if (lineupA.length === 0 || lineupB.length === 0) {
    return null;
  }

  return (
    <Grid container spacing={2} sx={{ my: 2 }}>
      {[
        { user: userA, lineup: lineupA },
        { user: userB, lineup: lineupB },
      ].map(({ user, lineup }, idx) => (
        <Grid item xs={6} key={idx}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ textAlign: "center" }}>
                {user?.username || "Unknown"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ textAlign: "center" }}>
                {user ? `${user.wins}-${user.losses} ` : ""}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h2" sx={{ textAlign: "center" }}>
                {getLineupScore(lineup)}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ textAlign: "center" }}>
                {getLineupFpts(lineup)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}
